import { takeEvery, put, call, Effect, select } from "redux-saga/effects";
import { FormsService } from "../../../services/forms";
import { updateHubspotPropertyFailure, updateHubspotPropertySuccess } from "../../auth/actionCreators";
import { AuthActionTypes, UpdateHubspotPropertyRequestActionType } from "../../auth/types";

function* updateHubspotPropertySaga(action: UpdateHubspotPropertyRequestActionType): Generator<Effect, void, any> {
    try {
        const { tableName, fields } = action.payload;
        const formId: string = yield select(state => state.forms.current._id);

        const formattedFields = Object.keys(fields).reduce((acc: any, key) => {
            acc[key] = fields[key];
            return acc;
        }, {});
        const data = { tableName, fields: formattedFields };

        const response = yield call(() => FormsService.updateHubspotProperty(formId, data));
        if (response.success) {
            yield put(updateHubspotPropertySuccess(response));
        } else {
            yield put(updateHubspotPropertyFailure(response.message || "Failed to update Hubspot Sheets config"));
        }
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to update Hubspot Sheets";
        console.error("Error updating Hubspot Sheets config:", error);
        yield put(updateHubspotPropertyFailure(errorMessage));
    }
}
export function* watchUpdateHubspotProperty() {
    yield takeEvery<UpdateHubspotPropertyRequestActionType>(
        AuthActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST,
        updateHubspotPropertySaga,
    );
}
